import { Grid, Link, Typography } from '@material-ui/core';

import { TextFieldElement } from 'react-hook-form-mui';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { OndemandAdminInputProps } from '../types';

export function OndemandAdminInput(props: OndemandAdminInputProps) {
  const classes = useStyles();
  const label = 'Justification';

  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          disabled={props.disabled}
          name="justification"
          label={label}
          variant="outlined"
          className={classes.root}
          fullWidth
          required
          placeholder="Enter Justification"
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              Submit will be disabled if you are not eligible to request access
              or have an active session. For more information refer to
              <Link
                target="_blank"
                href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/infrastructure/aws/on-demand-admin-access"
              >
                On-Demand Admin Access Documentation
              </Link>
              .
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
